export const LEGAL_PRICE_AND_TAX_CHANGES: string = `

### <!--= ++sectionIndex -->. Price and Tax Changes
<!-- subSectionIndex = 0; -->

#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Price Changes

We reserves the right to modify the prices of its products and services at any time, without prior notice. However, any such changes will not affect transactions that have already been completed or subscriptions that are already active at the time of the price change. Therefore, the prices of our products and services can change at any time. We recommend customers to regularly check the latest prices before making a purchase.

#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Tax Changes

Our products and services are available internationally. All prices displayed on our website exclude any applicable taxes, including Value Added Tax (VAT). The VAT rates may vary depending on your location and the specific tax regulations of your country.

By purchasing our products or services, you acknowledge and agree to bear any applicable VAT or other taxes that might be imposed by your local authorities. It is your responsibility to pay the correct amount of VAT or taxes payable in accordance with the regulations in your jurisdiction.

We shall not be held responsible for any changes in VAT rates or any additional taxes or fees imposed by your local authorities.
`;
